<script setup>
import Header from "@/components/layout/Header.vue";
import SharedCardUndanews from "@/components/shared/SharedCardUndanews.vue";
import SharedCardUndanitas from "../components/shared/SharedCardUndanitas.vue";
import SharedModal from "@/components/shared/SharedModal.vue";
import moment from "moment";
// import SharedButtonPlus from "../components/shared/SharedButtonPlus.vue";
import UndanewsCDialog from "@/components/shared/UndanewsCDialog.vue";
import UndanitasCDialog from "@/components/shared/UndanitasCDialog.vue";
import { computed, onMounted, ref } from "vue";
import { useAuthStore } from "@/app/stores/authStore";
import { useHomeContentStore } from "@/app/stores/homeContentStore";
// import { useRouter } from "vue-router";
import HolidaysCard from "@/components/shared/Home/HolidaysCard.vue";
import BirthdaysCard from "@/components/shared/Home/BirthdaysCard.vue";
import FestivitiesCard from "@/components/shared/Home/FestivitiesCard.vue";
import Inbox from "@/components/shared/Home/Inbox.vue";
// import { Select, CloseBold } from '@element-plus/icons-vue';

const authStore = useAuthStore();
const homeContentStore = useHomeContentStore();
// const router = useRouter();
// eslint-disable-next-line no-unused-vars
const showFullHolidays = ref(false);
const remitter = ref("");
const restHoliday = ref(null);
// eslint-disable-next-line no-unused-vars
const undanitas = ref([]);
// eslint-disable-next-line no-unused-vars
const festive = ref({
  nationals: "",
  local: [],
});
// eslint-disable-next-line no-unused-vars
const interval = ref(null);

// eslint-disable-next-line no-unused-vars
const user = computed(() => authStore.getUserLogged);
// eslint-disable-next-line no-unused-vars
const selfHoliday = computed(() => (restHoliday.value === 0 ? " ESTÁS DE VACACIONES" : ""));

const showInfoPopup = ref(false);
const pressedButton = ref(false);
const startPopUp = ref(new Date(2025, 4, 6, 0, 0, 0, 0));
const endPopUp = ref(new Date(2025, 4, 16, 0, 0, 0, 0));


onMounted(async () => {
  await homeContentStore.setShowDialogUndanews(false);
  await homeContentStore.setShowDialogUndanita(false);
  remitter.value = user.value?.name || "";
  const now = new Date();
  if (startPopUp.value.getTime() <= now && now <= endPopUp.value.getTime()) {
    checkInfoPopup();
  } else {
    const alreadyShown = localStorage.getItem('loginInfoPopUp')
    if (alreadyShown) {
      localStorage.removeItem('loginInfoPopUp')
    }
  }
})
// eslint-disable-next-line no-unused-vars
const formatTime = (value) => {
  if (value) {
    return moment(value).format("hh:mm A");
  }
  return "";
}
// eslint-disable-next-line no-unused-vars
const sendMessage = () => {
  return true;
}

// Modal info

const checkInfoPopup = () => {

  const popupFlag = authStore.showLoginPopup;
  const alreadyShown = localStorage.getItem('loginInfoPopUp')
  if (popupFlag && !alreadyShown) {
    showInfoPopup.value = true;
    localStorage.setItem('loginInfoPopUp', 'true');
    authStore.setShowLoginPopup(false)
  }
}

const closeInfoPopup = () => {
  pressedButton.value = true;
  closeModalShowInfoPopUp();
}

const closeModalShowInfoPopUp = () => {
  if (pressedButton.value) {
    showInfoPopup.value = false;
  }
}
</script>

<template>
  <div id="home">
    <Header title="Hoy es" :show-card="true" />
    <div id="body-content" class="d-flex row">
      <div class="d-flex row body-cards col-12">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <HolidaysCard />
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <!-- Cumpleaños -->
          <BirthdaysCard />
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <!-- Festivos -->
          <FestivitiesCard />
        </div>
      </div>
      <Inbox />
    </div>
    <div class="row" v-if="false">
      <div class="col-md-6">
        <shared-card-undanews title="Cultura" />
      </div>
      <div class="col-md-6">
        <shared-card-undanitas title="UndaDocs" />
      </div>
    </div>

    <el-dialog v-model="homeContentStore.showDialogUndanews" width="90%" :height="800" :show-close="false"
      style="max-width: 900px; border-radius:10px; overflow-y:auto;">
      <UndanewsCDialog />
    </el-dialog>
    <el-dialog v-model="homeContentStore.showDialogUndanita" width="90%" :height="800" :show-close="false"
      style="max-width: 900px; border-radius:10px; overflow-y:auto;">
      <UndanitasCDialog />
    </el-dialog>
    <shared-modal v-if="showInfoPopup" :theme="'blue'" :size="'medium'" :info="true" @close="closeModalShowInfoPopUp()">
      <template #content>
        <div class="d-flex row">
          <div class="col-7 mt-2 justify-content-center align-items-center popup-img">
            <img id="info-img" src="~@/assets/images/POPUP-MICROSOFT.png" width="400" alt="Imagen Atención"
              class="d-block mx-auto">
          </div>
          <div class="col-5 mt-2  popup-text">
            <h2 style="font-weight: 800;font-size: 35px;">Microsoft 365</h2>
            <span style="font-size: 20px;"><b>A partir de hoy,</b> comenzamos a trabajar exclusivamente en la nueva
              plataforma de <b>Microsoft
                365.</b><br><br>Ya
              puedes acceder a tu correo, documentos y herramientas colaborativas desde este nuevo entorno.
              <br><br><b>Si tienes dudas o necesitas ayuda contacta con el equipo de IT.<br><br>¡Gracias por adaptarte y
                avanzar
                con nosotros!</b></span>
            <div class="d-flex justify-content-end mt-3">
              <button class="btn btn_yellow" @click="closeInfoPopup">
                ENTENDIDO
              </button>
            </div>
          </div>
        </div>
      </template>
    </shared-modal>
    <!-- <el-dialog v-model="showInfoPopup" :width="980" :height="500" :close-on-click-modal="false" :show-close="false">
      <div class="d-flex row">
        <div class="col-7 mt-2">
          p
        </div>
        <div class="col-5 mt-2">
          <h2>Mircrosoft 365</h2>
          <span>A partir de hoy, comenzamos a trabajar exclusivamente en la nueva plataforma de Microsoft 365.<br><br>Ya
            puedes acceder a tu correo, documentos y herramientas colaborativas desde este nuevo entorno.
            <br><br>Si tienes dudas o necesitas ayuda contacta con el equipo de IT.<br><br>¡Gracias por adaptarte y
            avanzar
            con nosotros!</span>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn_yellow" @click="closeInfoPopup" style="width: 300px;">
          Lo he leído todo
        </button>
      </div>
    </el-dialog> -->
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/sass/styles.scss";


.el-dialog__body {
  background: #f3f0fb !important;
  min-height: 800px !important;
}

.close-icon {
  width: 8%;
  height: 20%;
}

.inter-icon {
  width: 2%;
  height: 2%;
}

#asterisk {
  position: absolute;
  vertical-align: super;
  height: auto;
  width: 2.2em;
  fill: #f9156f;
}

.el-dialog__header {
  padding: 0;
}

.my-header {
  margin-top: 2px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.text-header {
  text-align: left;
  font-size: 4em;
  font-weight: 900;
  letter-spacing: -0.05em;
  color: #f9156f;
}

.btn-action {
  width: 200px;
  height: 40px;
}

@media (max-width: 1580px) {
  #info-img {
    width: 100%;
  }
}

@media (max-width: 800PX) {
  .popup-text {
    width: 100%;
  }

  .popup-img {
    width: 0%;
    display: none;
  }
}

@media(max-width: 767px){
  .body-cards{
    order: 2;
    padding: 0;
    margin: 0;
  }
}
</style>
